import { useViewport } from 'components/general/useViewPort';
import React, { useState, useEffect } from "react";
import { NocMemo as Noc } from 'components/presentation/Noc';
import Label from "components/general/Label"
import Table from 'react-bootstrap/Table';
import { Pictogram } from 'components/presentation/Pictogram';
import Competitor from 'components/presentation/Competitor';
import Collapse from 'react-bootstrap/Collapse';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";


// render a single group. Group can be: the peloton, some chansing groups or the leader(s)
const RenderSingleGroup = ({ group, participants }) => {
  const { breakPoint } = useViewport();

  useEffect(() => {
    if (breakPoint === "sm" || breakPoint === "xs") {
      //setOpen(false);
      setDiffOpened('')
      setDiffClosed(groupCode !== 'LEAD' ? group.ei_value : '')
    }
  }, [breakPoint])


  const { mirs_rsc, mirs_discipline } = useUrlFriendlyToParameters();

  // hide/show riders list in a group

  // number of riders
  const ridersNum = group?.extensions?.find(item => item.eie_code === 'RIDERS_NUM')?.eie_value

  // speed of peloton or chasing groups or leader(s)
  const speed = group?.extensions?.find(item => item.eie_code === 'SPEED')?.eie_value

  // code of group. Needed to choose some texts
  const groupCode = group?.extensions?.find(item => item.eie_code === 'GROUP_NAME')?.eie_value

  // header text depending on code of group
  const header_text = groupCode === 'LEAD' ? <Label data={'Leaders'} sport={mirs_discipline} /> : groupCode === 'CHASE' ? <Label data={'ChasingGroup'} sport={mirs_discipline} /> : <Label data={'Peloton'} sport={mirs_discipline} />

  // speed text depending on code of group
  const speed_text = groupCode === 'LEAD' ? <Label data={'LeadersGroup'} sport={mirs_discipline} /> : groupCode === 'CHASE' ? <Label data={'ChasingGroup'} sport={mirs_discipline} /> : <Label data={'PelotonGroup'} sport={mirs_discipline} />

  // getting codes of raiders from extensions of extended info GROUP
  const ridersGroup = group?.extensions?.filter(item => item.eie_code === 'RIDER')?.sort((a, b) => (0 + a.ei_pos) - (0 + b.ei_pos));

  const [open, setOpen] = useState(false);
  const [diffClosed, setDiffClosed] = useState(groupCode !== 'LEAD' ? group.ei_value : '');
  const [diffOpened, setDiffOpened] = useState('');

  const handleClick = () => {
    //if (breakPoint !== "sm" && breakPoint !== "xs") {
    setOpen(!open);
    if (open) {
      setDiffOpened('')
      setDiffClosed(groupCode !== 'LEAD' ? group.ei_value : '')
    } else {
      setDiffClosed('')
      setDiffOpened(groupCode !== 'LEAD' ? group.ei_value : '')
    }
    //}
  }

  // for each rider belonging a group, it is needed to get its bib, name, shortName, etc
  const ridersGroupData = []
  ridersGroup?.forEach(el => {
    const participant = participants.find(i => i?.participant.code === el.eie_value);
    const riderData = {
      bib: participant?.bib,
      participant: participant?.participant
    }
    ridersGroupData.push(riderData);
  });
  return (
    <li onClick={() => handleClick()}
      aria-controls={`${mirs_rsc}_#${group.ei_pos}`}
      aria-expanded={open}
      id={`mirs-racegroups-${mirs_rsc}_#${group.ei_pos}`}
    >
      <div className='container'>
        <div className='box-header'>
          <div className='title'> {header_text}</div>
          <div className='image'><Pictogram discipline={mirs_discipline} picto={groupCode === 'LEAD' ? 'leader' : 'chassing-group'} /></div>
          <div className='time'>{diffClosed}</div>
          <div className='riders'>{ridersNum} {ridersNum ? <Label data={'Riders'} sport={mirs_discipline} /> : ''}</div>
        </div>
        <Collapse in={open}>
          <div className='box-content' id={`${mirs_rsc}_#${group.ei_pos}`} >
            <div className='header'><span>{speed_text}:</span> {diffOpened ? `${diffOpened} - ` : ''} {speed}km/h</div>
            {
              ridersGroupData.length > 0 &&
              <div className='content'>
                <Table striped bordered hover>
                  <thead>
                    <tr><th><Label data={'HeaderRaceNo'} sport={mirs_discipline} /></th><th colSpan={2}><Label data={'LabelName'} sport={mirs_discipline} /></th></tr>
                  </thead>
                  <tbody>
                    {
                      ridersGroupData.map(rider => <RenderSingleRider rider={rider} key={rider?.participant?.code} />)
                    }
                  </tbody>
                </Table>
              </div>
            }
          </div>
        </Collapse>
      </div>
    </li>
  )
}

// render the participants belonging a group. Group can be: the peloton, a chasing group or the leader(s)
const RenderSingleRider = ({ rider }) => {
  return (
    <tr>
      <td>{rider?.bib}</td>
      <td><Noc code={rider?.participant?.organisation?.code} longDescription={rider?.participant?.organisation?.description} hideNocCode={true} /></td>
      <td>
        <Competitor
          name={rider?.participant?.name}
          shortName={rider?.participant?.shortName}
          code={rider?.participant?.code}
          hidePicture={true}
          alwaysNoc={false}
        />
      </td>
    </tr>
  )
}

const RaceGroups = ({ data }) => {
  const { breakPoint } = useViewport();

  // list of groups during the race. Groups can be: peloton, some chasing group, and leader(s)
  let groups = data?.currentExtendedInfos?.filter(item => item.ei_code === 'GROUP' && item.ei_type === 'BREAKAWAY')?.sort((a, b) => (0 + b.ei_pos) - (0 + a.ei_pos));



  return (
    <div className="race-groups-main">
      <ul>
        {groups && groups?.map(group => <RenderSingleGroup group={group} participants={data?.items} key={group.ei_pos} />)}
      </ul>
    </div>
  )
}

export default RaceGroups
